enum OsdLogsSearchPageModeEnum {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  PREVIEW = 'PREVIEW',
}

export default OsdLogsSearchPageModeEnum;
